import axios from 'axios';
import setAuthToken from './setAuthToken';
import { SESSION_EXPIRED } from '../actions/types';

// Two jobs, both on every API response, installed once at startup.
//
// 1. Pick up the sliding-window replacement token. middleware/auth.js
//    hands one back on the x-refreshed-token header once the current one
//    is past half its life, so anybody actually using the app never
//    reaches an expiry at all -- the 30 days only elapse during real
//    inactivity, when nothing is open and there is no work to lose.
//
// 2. Turn a session-ended 401 into SESSION_EXPIRED rather than letting
//    each caller invent its own handling. The distinction from a plain
//    auth failure comes from the server's `code`, so a malformed or
//    forged token is not presented to a customer as "your session
//    expired".
//
// What this deliberately does NOT do is log the customer out. See the
// SESSION_EXPIRED case in reducers/registerUser.js: clearing isAuth
// unmounts every editing screen, which is precisely how a lapsed session
// turns into lost work.
const SESSION_ENDED_CODES = ['session_expired', 'password_changed'];

const installSessionInterceptors = (store) => {
  axios.interceptors.response.use(
    (response) => {
      const refreshed = response.headers && response.headers['x-refreshed-token'];
      if (refreshed) {
        localStorage.setItem('token', refreshed);
        setAuthToken(refreshed);
      }
      return response;
    },
    (error) => {
      const res = error.response;
      const code = res && res.data && res.data.code;
      if (res && res.status === 401 && SESSION_ENDED_CODES.includes(code)) {
        store.dispatch({
          type: SESSION_EXPIRED,
          payload: { msg: res.data.msg, code },
        });
      }
      // Rethrown either way -- callers still need to know their request
      // failed, and the ones with unsaved work use it to hold on to it.
      return Promise.reject(error);
    }
  );
};

export default installSessionInterceptors;
